import { useQuery } from 'react-query';

import { adminDailyCallsService } from '@project/services';
import { Guid } from '@project/types';

export const useCallContactCheckStatus = (userId: Guid) => {
  return useQuery<boolean, Error>(
    ['CallContactDoNotContactCheck', userId],
    () => adminDailyCallsService.callContactDoNotContactCheck(userId),
    {
      enabled: !!userId,
    },
  );
};
